import { useState } from 'react';

import InfiniteScroll from '../InfiniteScroll/InfiniteScroll';
import { Masonry } from 'react-plock';

import { XL, MEDIUM, LARGE } from '@hooks/useScreenWidth';
import { Post } from '../PostsViewer/types/Post';
import { SinglePostListItem } from '../PostsViewer/components/SinglePostListItem/SinglePostListItem';
import { Instagram as PostItemLoader } from 'react-content-loader';
import { AppDownloadModal } from '../AppDownloadModal/AppDownloadModal';

interface IProps {
  posts: Post[];
  fetchMore: () => Promise<unknown>; // The result is not used, but it must be a promise so that InfiteScroll doesn't keep requesting more loads.
  hasMore: boolean;
  config?: {
    columns: number | number[];
    gap: number | number[];
    media?: number[];
    useBalancedLayout?: boolean;
  };
  appDownloadModalHeader?: string;
  appDownloadModalText?: string;
}

const GAP_SIZE_PX = 16; // 1rem = 16px
const DEFAULT_CONFIG = {
  columns: [1, 2, 3],
  gap: [GAP_SIZE_PX, GAP_SIZE_PX, GAP_SIZE_PX],
  media: [MEDIUM, LARGE, XL],
  useBalancedLayout: true,
};

export const PostsMasonry = ({
  posts,
  fetchMore,
  hasMore,
  config = DEFAULT_CONFIG,
  appDownloadModalHeader,
  appDownloadModalText,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);

  const loaderItems = Array.from({ length: 3 }, (_, i) => i);

  return (
    <>
      <InfiniteScroll
        dataLength={posts.length}
        loader={
          <Masonry
            items={loaderItems}
            config={config}
            render={(_, idx) => (
              <PostItemLoader key={idx} uniqueKey={`PostsMasonry-loader-${idx + 1}`} />
            )}
          />
        }
        next={fetchMore}
        hasMore={hasMore}
      >
        <Masonry
          items={posts}
          config={config}
          render={(post, idx) => (
            <SinglePostListItem
              key={`post-${post._id}-${idx}`}
              className="border-lake-fog bg-sea-foam w-full rounded-lg border-2"
              post={post}
              onNotLoggedIn={() => {
                setIsAppDownloadModalOpen(true);
              }}
            />
          )}
        />
      </InfiniteScroll>
      <AppDownloadModal
        appDownloadSource="PostsMasonry"
        modalHeader={appDownloadModalHeader ?? undefined}
        modalText={appDownloadModalText ?? undefined}
        showTextOnMobile
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </>
  );
};
